<template>
  <div>
    <qx-card :title="this.$route.path.includes('gasCard')?'气卡详情':'油卡详情'" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box v-for="(data, index) in detailData" :data="data" :key="index" />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox v-if="$route.query.type" :busiId="$route.query.id" busiCode="100000" />
  </div>
</template>

<script>
import {
  oilDetail, // 获取详情
} from 'api/service';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  data () {
    return {
      loading: false,
      detailData: {
        base: {
          label: '油卡信息',
          tableData: {
            title: [
              {
                prop: 'cardTypeName',
                label: '来源类型',
              },
              {
                prop: 'parentOilCarNum',
                label: '主卡卡号',
              },
              {
                prop: 'companyName',
                label: '服务商',
              },
              {
                prop: 'oilCardTypeName',
                label: '油卡类型',
              },
              {
                prop: 'oilCarNum',
                label: '子卡卡号',
              },
              {
                prop: 'oilCardStatusName',
                label: '油卡状态',
              },
              {
                prop: 'cardBalanceStr',
                label: '理论余额',
                unit: '元',
              },
              {
                prop: 'plateNumber',
                label: '绑定车辆',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/service/oil/daughterCardManage/detail' && this.$route.path !== '/manage/service/gasCard/daughterCardManage/detail') {
        return;
      }
      this.loading = true;
      const detailRes = await oilDetail({
        cardId: this.$route.query.id,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        detailRes.cardBalanceStr = detailRes.cardBalance / 100;
        if (detailRes.vehicleNumbers) {
          detailRes.plateNumber = detailRes.vehicleNumbers.join('，');
        }
        this.detailData.base.tableData.data = detailRes;
        // this.detailData.car.tableData.data = detailRes;
      }
    },
  },
  created () {
    this.getData();
    if (this.$route.path.includes('gasCard')) {
      this.detailData.base.label = '气卡信息';
      this.detailData.base.tableData.title.forEach((item) => {
        if (item.label.includes('油卡')) {
          item.label = item.label.replace(/油卡/g, '气卡');
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
